export default __webpack_public_path__ + "static/media/drapeau-benin.00f88aec.jpg";